import React, {Component} from "react";
import {connect} from "react-redux";
import {showToastForBackend, showToastForFrontend} from "../../actions/toastActions";
import {FormattedMessage} from "react-intl";
import Axios from "axios";
import getAxiosConfig from "../../utils/axiosConfig";
import urlList from "../../reducers/propertiesReducer";
import messageCodes from "../../utils/messageCodes";

class AccountInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPassword: this.props.currentPassword,
            newPassword: this.props.newPassword,
            confirmPassword: this.props.confirmPassword,
            errorText: this.props.errorText
        }

        this.logout = this.logout.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateUser = this.updateUser.bind(this);
    }

    logout(){
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        this.setState({
            user : null,
            redirect2Root: true
        });
        window.location.assign("/");
    }

    updateUser(event) {
        event.preventDefault();
        if (this.state.confirmPassword !== this.state.newPassword) {
            this.setState({errorText: "Confirmed passwords does not match new password"});
            return;
        } else if (!this.state.confirmPassword || !this.state.newPassword || !this.state.currentPassword) {
            this.setState({errorText: "All 3 password fields must be filled out"});
            return;
        } else if (this.state.newPassword === this.state.currentPassword) {
            this.setState({errorText: "New password should be different from current one "});
            return;
        } else {
            this.setState({errorText: ""});
        }

        Axios.put(
            `${urlList().updatePasswordUrl}`,
            {
                id: this.state.id,
                currentPassword: this.state.currentPassword.trim() ? this.state.currentPassword.trim() : null,
                newPassword: this.state.newPassword.trim() ? this.state.newPassword.trim() : null
            },
            getAxiosConfig()
        ).then((response) => {
            if(response) {
                this.setState({errorText: response.data});
                this.logout();
            }
        }).catch(err => {
            if (err.response)
                this.setState({errorText: err.response.data});
            else
                this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR)

            this.setState({

            });
        });
    }

    handleChange({target}) {
        this.setState({[target.name]: target.value});
    }

    getUserEmail() {
        return localStorage.getItem(`user`);
    }

    render() {
        let bearerToken = localStorage.getItem(`token`);

        let activeStatus = 0;
        if (bearerToken) {
            bearerToken = bearerToken.replace('Bearer ', '');

            const bearerTokenInformation = bearerToken.substring(bearerToken.indexOf('.') + 1, bearerToken.lastIndexOf('.'));
            const decoded = atob(bearerTokenInformation);
            const decodedObject = JSON.parse(decoded);
            activeStatus = decodedObject.activeStatus;
        }


        return (
            <div className="account-info">
                <div className="header">
                    {(activeStatus === 2)? <FormattedMessage id="Password must be updated"/> : ""}</div>
                    <form className="form" onSubmit={this.updateUser}>
                        <div className="form-row">
                            <div className="form-label">
                                <FormattedMessage id="Email"/>
                            </div>
                            <input
                                className="user-input"
                                name="email"
                                value={this.getUserEmail()}
                                readOnly
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-label"><FormattedMessage id="Current password"/></div>
                            <input
                                className="user-input"
                                name="currentPassword"
                                value={this.state.currentPassword}
                                onChange={this.handleChange}
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-label"><FormattedMessage id="New Password"/></div>
                            <input
                                className="user-input"
                                name="newPassword"
                                value={this.state.newPassword}
                                onChange={this.handleChange}
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-label">
                                <FormattedMessage id="Confirm Password"/></div>
                            <input
                                className="user-input"
                                name="confirmPassword"
                                value={this.state.confirmPassword}
                                onChange={this.handleChange}
                            />
                        </div>

                        <div style={{display: this.state.errorText ? "block" : "none"}} className="row form-error">
                            <div className="user-input">{this.state.errorText}</div>
                        </div>

                        <div className="button-container">
                            <button className="save-btn" onClick={this.updateUser}>
                                <FormattedMessage id="Update Password"/>
                            </button>
                        </div>
                    </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties
    };
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(AccountInfo);